var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-ad-wrapper-background"},[_c('div',{staticClass:"page-help new-ad-wrapper"},[_c('manual',{attrs:{"params":_vm.params,"custom":true,"manualInfo":_vm.manualInfo}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }